import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updatesAPI } from "components/Apis/updates";

export const fetchUpdates = createAsyncThunk(
    "updates/fetchUpdates",
    async ({ page = 1, page_size = 25, filters = {}, append = false } = {}, { rejectWithValue }) => {
        try {
            const response = await updatesAPI.getUpdates(page, page_size, filters);
            return { response, page, page_size, filters, append };
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const getResultsPayload = (payload) => {
    if (payload && Array.isArray(payload.results)) {
        return {
            updates: payload.results,
            count: payload.count ?? payload.results.length,
            next: payload.next ?? null,
            previous: payload.previous ?? null,
        };
    }
    if (Array.isArray(payload)) {
        return {
            updates: payload,
            count: payload.length,
            next: null,
            previous: null,
        };
    }
    return {
        updates: [],
        count: 0,
        next: null,
        previous: null,
    };
};

const updatesSlice = createSlice({
    name: "updates",
    initialState: {
        updates: [],
        count: 0,
        next: null,
        previous: null,
        page: 1,
        pageSize: 25,
        filters: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUpdates.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUpdates.fulfilled, (state, action) => {
                state.loading = false;
                const { response, page, page_size, filters, append } = action.payload;
                const normalized = getResultsPayload(response);
                state.updates = append
                    ? state.updates.concat(normalized.updates)
                    : normalized.updates;
                state.count = normalized.count;
                state.next = normalized.next;
                state.previous = normalized.previous;
                state.page = page;
                state.pageSize = page_size;
                state.filters = filters || {};
            })
            .addCase(fetchUpdates.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default updatesSlice.reducer;
